module.exports = __webpack_public_path__ + "static/media/luigi_0.3e1b5082.png";